import { useEffect } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { paths, TAB_ROUTE_MAP } from '../../routes';

/**
 * Handles legacy `?tab=` query params and redirects to the new path-based routes.
 * Also serves as the index route — redirects to /apps by default.
 *
 * Examples:
 *   /orgs/1?tab=roles     → /orgs/1/roles
 *   /orgs/1?tab=pipelines → /orgs/1/pipelines-list
 *   /orgs/1               → /orgs/1/apps
 */
const TabRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { orgId } = useParams();

  useEffect(() => {
    const tab = searchParams.get('tab');

    if (tab) {
      // Tabs that navigate to standalone routes (outside AppDashboard)
      if (tab === 'monitoring') {
        navigate(paths.monitor(orgId), { replace: true });
        return;
      }
      if (tab === 'interfaces') {
        navigate(paths.interfaces(orgId), { replace: true });
        return;
      }
      if (tab === 'config' || tab === 'database') {
        navigate(paths.interfaces(orgId), { replace: true });
        return;
      }

      // Map to nested route segment
      const segment = TAB_ROUTE_MAP[tab];
      if (segment) {
        navigate(paths.orgTab(orgId, segment), { replace: true });
        return;
      }
    }

    // Default: redirect to apps
    navigate(paths.orgTab(orgId, 'apps'), { replace: true });
  }, [searchParams, navigate, orgId]);

  return null;
};

export default TabRedirect;
